export const normalizeTrustAddress = value => {
  return typeof value === "string" ? value.trim().toLowerCase() : "";
};

export const getSenderAddress = from => {
  if (Array.isArray(from)) {
    return getSenderAddress(from[0]);
  }

  if (from && typeof from === "object") {
    return normalizeTrustAddress(from.address || from.email);
  }

  return normalizeTrustAddress(from);
};

export const getSenderDomain = address => {
  const normalizedAddress = normalizeTrustAddress(address);
  const separatorIndex = normalizedAddress.lastIndexOf("@");

  if (
    separatorIndex < 1 ||
    separatorIndex === normalizedAddress.length - 1
  ) {
    return "";
  }

  return normalizedAddress.slice(separatorIndex + 1);
};

export const isSenderTrusted = (from, trustedAddresses = []) => {
  const address = getSenderAddress(from);
  const domain = getSenderDomain(address);

  if (!address) {
    return false;
  }

  return trustedAddresses.some(item => {
    const trustedAddress = normalizeTrustAddress(
      typeof item === "string" ? item : item?.address
    );

    return (
      trustedAddress === address || (!!domain && trustedAddress === domain)
    );
  });
};
